import api from './api';

const conversationApi = {
  /**
   * Récupérer le nombre de messages non lus par réservation
   */
  getUnreadCounts: async () => {
    const response = await api.get('/conversations/unread-counts');
    return response.data;
  },

  /**
   * Récupérer toutes les conversations de l'utilisateur
   */
  getConversations: async () => {
    const response = await api.get('/conversations');
    return response.data;
  },

  /**
   * Récupérer une conversation par ID de réservation
   */
  getConversation: async (reservationId) => {
    const response = await api.get(`/conversations/${reservationId}`);
    return response.data;
  },

  /**
   * Envoyer un message dans une conversation
   */
  sendMessage: async (conversationId, messageData) => {
    const response = await api.post(`/conversations/${conversationId}/messages`, messageData);
    return response.data;
  },

  /**
   * Marquer un message comme lu
   */
  markAsRead: async (conversationId, messageId) => {
    const response = await api.put(`/conversations/${conversationId}/messages/${messageId}/read`);
    return response.data;
  },

  /**
   * Marquer tous les messages d'une conversation comme lus
   */
  markAllAsRead: async (conversationId) => {
    const response = await api.put(`/conversations/${conversationId}/read-all`);
    return response.data;
  },

  /**
   * Uploader un fichier pour un message
   */
  uploadAttachment: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/conversations/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  }
};

export default conversationApi;
